// import { Button } from "@mui/material";
// // import { Button, Switch } from "@mui/material";
// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { NavLink, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import { baseUrl } from "../../Config/baseUrl";

// export default function FAQpages() {
//   const [data, setData] = useState([]);
//   const navigate = useNavigate();

//   const getCreer = () => {
//     axios
//       .get(`${baseUrl}/blog/frontend-page-id-api/`, {
//         headers: {
//           Authorization: `Token ${localStorage.getItem("token")}`,
//           "Access-Control-Allow-Origin": "*",
//         },
//       })
//       .then((res) => {
//         setData(res.data?.data);
//       })
//       .catch((err) => {
//         toast.error("Error deleting blog", err?.response?.data?.message);
//       });
//   };
//   const deleteFAQ = (id) => {
//     axios
//       .delete(`${baseUrl}/blog/frontend-page-id-api/`, {
//         data: { page_id: id },
//         headers: {
//           Authorization: `Token ${localStorage.getItem("token")}`,
//           "Access-Control-Allow-Origin": "*",
//         },
//       })
//       .then((res) => {
//         console.log("Blog deleted successfully");
//         getCreer();
//         toast.success(res?.data?.message);
//       })
//       .catch((err) => {
//         toast.error("Error deleting blog", err?.response?.data?.message);
//       });
//   };
//   //   const toggleStatus = (item) => {
//   //     axios
//   //       .patch(
//   //         `${baseUrl}/blog/frontend-page-id-api/`,
//   //         {
//   //           page_id: item.id,
//   //           is_active: !item.is_active,
//   //         },
//   //         {
//   //           headers: {
//   //             Authorization: `Token ${localStorage.getItem("token")}`,
//   //             "Access-Control-Allow-Origin": "*",
//   //           },
//   //         },
//   //       )
//   //       .then((res) => {
//   //         toast.success(res.data.message);
//   //         getCreer();
//   //       })
//   //       .catch((err) => {
//   //         toast.error(err?.response?.data?.message || "Something went wrong");
//   //       });
//   //   };

//   useEffect(() => {
//     getCreer();
//   }, []);

//   return (
//     <>
//       <p className="my-3 sm:my-0 text-5xl text-center text-blue-900 underline">
//         Pages
//       </p>
//       <div className="flex justify-end item-center w-[100%]">
//         <NavLink to="/page/add">
//           <div className="text-xl font-bold !text-gray-600 px-3 pb-1 pr-[10%]">
//             <Button variant="outlined">Add</Button>
//           </div>
//         </NavLink>
//       </div>
//       <div className="overflow-x-auto">
//         <table className="min-w-full border border-collapse border-gray-300 table-auto">
//           <thead>
//             <tr className="bg-gray-100 border-b">
//               <th className="px-4 py-1 text-lg font-semibold text-left text-black">
//                 Name
//               </th>
//               <th className="px-4 py-1 text-lg font-semibold text-left text-black">
//                 Path
//               </th>
//               {/* <th className="px-4 py-1 text-lg font-semibold text-center text-black">
//                 Status
//               </th> */}
//               <th className="px-4 py-1 text-lg font-semibold text-left text-black">
//                 Actions
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {data?.map((item) => (
//               <tr key={item.id} className="border-b hover:bg-gray-100">
//                 <td className="px-4 py-1 overflow-hidden text-lg text-black whitespace-nowrap text-ellipsis">
//                   <div
//                     className="text-lg text-black cursor-pointer"
//                     // onClick={() => navigate(`/faq/${item.id}`)}
//                   >
//                     {item.name}
//                   </div>
//                 </td>
//                 <td className="px-4 py-1 overflow-hidden text-lg text-black whitespace-nowrap text-ellipsis">
//                   <p className="">{item.path}</p>
//                 </td>
//                 <td className="px-4 py-1 text-center">
//                   <div className="flex items-center justify-center gap-2">
//                     {/* <Switch
//                       checked={item?.is_active}
//                       onChange={() => toggleStatus(item)}
//                       color="success"
//                     /> */}
//                     {/* <span
//                       className={`text-sm font-medium ${
//                         item?.is_active ? "text-green-600" : "text-red-600"
//                       }`}
//                     >
//                       {item?.is_active ? "Enabled" : "Disabled"}
//                     </span> */}
//                   </div>
//                 </td>
//                 <td className="px-4 py-1 text-lg text-black">
//                   <div className="flex justify-start space-x-4">
//                     <Button
//                       onClick={() =>
//                         navigate(`/page/update`, { state: item.id })
//                       }
//                       variant="outlined"
//                       className="px-4 py-1"
//                     >
//                       Update
//                     </Button>
//                     <Button
//                       onClick={() => deleteFAQ(item.id)}
//                       variant="outlined"
//                       className="px-4 py-1"
//                     >
//                       Delete
//                     </Button>
//                   </div>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </>
//   );
// }

import { Button } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { baseUrl } from "../../Config/baseUrl";
import { Input } from "react-mkx-components";

export default function FAQpages() {
  const [data, setData] = useState([]);

  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const getCreer = () => {
    axios
      .get(`${baseUrl}/blog/frontend-page-id-api/?search=${search}`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        setData(res.data?.data);
      })
      .catch((err) => {
        toast.error("Error deleting blog", err?.response?.data?.message);
      });
  };
  const deleteFAQ = (id) => {
    axios
      .delete(`${baseUrl}/blog/frontend-page-id-api/`, {
        data: { page_id: id },
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        console.log("Blog deleted successfully");
        getCreer();
        toast.success(res?.data?.message);
      })
      .catch((err) => {
        toast.error("Error deleting blog", err?.response?.data?.message);
      });
  };

  useEffect(() => {
    getCreer();
  }, [search]);

  return (
    <>
      <p className="my-3 sm:my-0 text-5xl text-center text-blue-900 underline">
        Pages
      </p>
      <div className="flex justify-between item-center w-[100%]">
        <div className="relative w-full max-w-sm">
          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full rounded-md border border-gray-300 px-4 py-2 text-sm 
                 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
          />
        </div>
        <NavLink to="/page/add">
          <div className="text-xl font-bold !text-gray-600 px-3 pb-1 pr-[10%]">
            <Button variant="outlined">Add</Button>
          </div>
        </NavLink>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full border border-collapse border-gray-300 table-auto">
          <thead>
            <tr className="bg-gray-100 border-b">
              <th className="px-4 py-1 text-lg font-semibold text-left text-black">
                Name
              </th>
              <th className="px-4 py-1 text-lg font-semibold text-left text-black">
                Path
              </th>
              <th className="px-4 py-1 text-lg font-semibold text-left text-black">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item) => (
              <tr key={item.id} className="border-b hover:bg-gray-100">
                <td className="px-4 py-1 overflow-hidden text-lg text-black whitespace-nowrap text-ellipsis">
                  <div
                    className="text-lg text-black cursor-pointer"
                    // onClick={() => navigate(`/faq/${item.id}`)}
                  >
                    {item.name}
                  </div>
                </td>
                <td className="px-4 py-1 overflow-hidden text-lg text-black whitespace-nowrap text-ellipsis">
                  <p className="">{item.path}</p>
                </td>
                <td className="px-4 py-1 text-lg text-black">
                  <div className="flex justify-start space-x-4">
                    <Button
                      onClick={() =>
                        navigate(`/page/update`, { state: item.id })
                      }
                      variant="outlined"
                      className="px-4 py-1"
                    >
                      Update
                    </Button>
                    <Button
                      onClick={() => deleteFAQ(item.id)}
                      variant="outlined"
                      className="px-4 py-1"
                    >
                      Delete
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
